export default {
    brandguidelines : [],
    cardoptions:[],
    selectedcard:"",
    createorder: [],
    itemstotal: [],
    createrequest: [],
    getrequest: [],
    selectedreq: [],
    getcomments: [],
    addcomments: [],
    previousRoute: "",
    getcoupons:[]
}